import React, { useEffect } from 'react'
import { FiCheckCircle } from "react-icons/fi";
import parse, { domToReact } from "html-react-parser";
import SkeletonLoaderAboutUs from '../../../Common/skeleton/SkeletonAboutUs/SkeletonLoaderAboutUs'
import Aos from 'aos'
const host = process.env.REACT_APP_API_SERVER
const AboutUs = ({ loadingHomeAboutNineSecDataApi, HomeAboutNineSecDataApiData, HomeAboutNineSecDataApiError, }) => {

    useEffect(function () {
        Aos.init({ duration: 1000 });
    }, []);
    return (
        <>
            {loadingHomeAboutNineSecDataApi ?
                <SkeletonLoaderAboutUs />
                :
                <section className="about-wrap style1" id="aboutus">
                    <div className="container" data-aos="fade-up">
                        <div className="heading">

                            <div className="section-header text-center">
                                <span className="ruby section-badge">

                                    ABOUT US

                                </span>
                            </div>
                        </div>
                        <div className="row gx-5 align-items-center">
                            <div className="col-lg-6">
                                <div className="about-sec-bg text-center">
                                    <img
                                        className="img-fluid"
                                        src={`${host}${HomeAboutNineSecDataApiData?.about_us_image}`}
                                        alt=""
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="about-content">
                                    <div className="content-title style2 mb-15">
                                        <h3 className="headin">{HomeAboutNineSecDataApiData?.about_us_title}</h3>
                                    </div>
                                    {/* <div className="about-points">
                                        <ul>
                                            {HomeAboutNineSecDataApiData?.about_us_subtitle ? parse(HomeAboutNineSecDataApiData?.about_us_subtitle) : ''}
                                        </ul>
                                    </div> */}

                                    <div className="about-points">
                                        {HomeAboutNineSecDataApiData?.about_us_subtitle &&
                                            parse(HomeAboutNineSecDataApiData?.about_us_subtitle, {
                                                replace: (domNode) => {
                                                    if (domNode.name === "li") {
                                                        return (
                                                            <li className="about-list-item">
                                                                <FiCheckCircle className="about-icon" />
                                                                {domToReact(domNode.children)}
                                                            </li>
                                                        );
                                                    }
                                                }
                                            })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>}
        </>
    )
}

export default AboutUs